import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { usePatient } from '../../../../Contexts/PatientContext';
import styles from './style.module.css';
import EyeLogo from './eye.svg';

const SearchTable = ({ data }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { updatePatient } = usePatient();

  const handleRowClick = (item) => {
    let context = 'dor';
    if (pathname.startsWith('/efeitos-adversos')) context = 'efeitos-adversos';
    else if (pathname.startsWith('/cirurgias')) context = 'cirurgias';
    if (item) {
      navigate(`/${context}/paciente`, { state: { data: item } });
    }
  };

  const statusLabels = {
    'imported': 'Ativo',
    'obito_por_cancer': 'Óbito por câncer',
    'obito_por_outra_causa': 'Óbito por outra causa',
    'obito_desconhecido': 'Óbito desconhecido',
    'saida_do_estudo_por_opcao': 'Saída do estudo por opção',
  };

  return (
    <div className={styles.tableContainer}>
      <table className={styles.customTable}>
        <thead>
          <tr>
            <th>Nome</th>
            <th>CPF</th>
            <th>Registro do Paciente</th>
            <th>Condição do Tratamento</th>
            <th>Ver Perfil do Paciente</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <tr key={index}>
              <td>{item.customer?.name}</td>
              <td>{item.customer?.personalNumber}</td>
              <td>{item.studyNumber}</td>
              <td>{statusLabels[item.status]}</td>
              <td>
                <button
                  className={styles.profileButton}
                  onClick={() => handleRowClick(item)}
                >
                  <img src={EyeLogo} alt="Ver Perfil" />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SearchTable;
